module.exports = __webpack_public_path__ + "img/about-us-2.fb2092d8.png";